export const sourceTitles = {
  googleadx: "Google AdX",
  openbidding: "Open Bidding",
  headerbidding: "Header Bidding",
};

export const matchSources = ["googleadx", "openbidding", "headerbidding"];
